//! proxy(미들웨어) 번들에 실리므로 @/api 배럴(생성 SDK 전체) 대신 leaf 모듈에서 가져온다.
import { TERM_CATEGORY } from '@/api/types/parent-code';
import { findRoute } from '@/utils/findRoute';

import {
  isStaticPath,
  matchesPrefix,
  type PartnerEntry,
  toDonationPath,
} from './partnerEntry';
import { DONATION_ROUTES, ROUTES } from './routes';

//* 약관은 동적 라우트(/terms/[category])라 카테고리 앞까지를 접두사로 쓴다.
const TERMS_PREFIX = ROUTES.TERMS.pathname({
  terms: TERM_CATEGORY.SERVICE_TERMS,
})
  .split('/')
  .slice(0, 2)
  .join('/');

//* 토스에서도 웰로 화면을 그대로 쓰는 경로 (제품 결정).
const WELLO_PREFIXES: readonly string[] = [
  DONATION_ROUTES.HOME.pathname,
  ROUTES.LOGIN.pathname,
  ROUTES.JOIN_COMMON.pathname,
  ROUTES.JOIN_COMPLETE.pathname,
  ROUTES.MY.pathname,
  ROUTES.POINT_MARKET.pathname,
  ROUTES.POINTS.pathname,
  ROUTES.EASY_CERTIFICATION.pathname,
  ROUTES.ACCOUNT_INTEGRATION.pathname,
  TERMS_PREFIX,
];

export const isReachableOnToss = (pathname: string) =>
  Boolean(findRoute(toDonationPath(pathname))) ||
  WELLO_PREFIXES.some((prefix) => matchesPrefix(pathname, prefix));

export const resolveTossEntry = (pathname: string): PartnerEntry => {
  if (isStaticPath(pathname)) {
    return { kind: 'pass' };
  }

  //* 같은 경로의 고기부 화면이 실재하면 그쪽이 정답이다(`/my` → `/donation/my`).
  const donationPath = toDonationPath(pathname);

  if (findRoute(donationPath)) {
    return { kind: 'redirect', pathname: donationPath };
  }

  if (WELLO_PREFIXES.some((prefix) => matchesPrefix(pathname, prefix))) {
    return { kind: 'pass' };
  }

  //* 토스에 열지 않은 화면은 라우트 유무와 무관하게 고기부 홈으로 보낸다.
  return { kind: 'redirect', pathname: DONATION_ROUTES.HOME.pathname };
};
